import classNames from 'classnames'
import { ErrorMessage, getIn } from 'formik'
import { Input } from 'reactstrap'
import EInvalidFeedback from '../EInvalidFeedback/EInvalidFeedback'
import Select from 'react-select'
import AsyncSelect from 'react-select/async'

import AsyncCreatableSelect from 'react-select/async-creatable'
import CreatableSelect from 'react-select/creatable'

const SelectField = ({ onlyShowOption, loadOptions, ...props }) => {
    const { option, hasOnChange, disabled } = props
    const errorMessage = getIn(props?.form?.errors, props?.field?.name)
    const isTouch = getIn(props?.form?.touched, props?.field?.name)

    const onChange = (e) => {
        props.form.setFieldValue(props.field.name, e.target.value)
        if (Array.isArray(props.resetvalue)) {
            // eslint-disable-next-line no-restricted-syntax
            for (const name of props.resetvalue) {
                props.form.setFieldValue(name, '', false)
            }
        }

        // props.
    }

    if (props.isSelect) {
        if (props.isAsyncSelect) {
            const colorStyles = {
                option: (styles, { data, isFocused, isSelected }) => {
                    let backgroundColor = 'white'
                    const color = 'black'

                    if (isSelected) {
                        // Use default selected background (React Select uses light gray by default)
                        backgroundColor = styles.backgroundColor // preserve default
                    } else if (data.highlight) {
                        backgroundColor = '#ffc107' // your custom highlight color
                    } else if (isFocused) {
                        backgroundColor = '#eee' // subtle hover/focus
                    }

                    return {
                        ...styles,
                        backgroundColor,
                        color,
                        cursor: 'pointer'
                    }
                }
            }
            return (
                <>
                    <AsyncSelect
                        // {...props.field}
                        // {...props}
                        isClearable={props.isClearable}
                        placeholder={props.placeholder}
                        cacheOptions={props.cacheOptions}
                        loadOptions={loadOptions}
                        className={classNames(props.className, {
                            'is-invalid': errorMessage && isTouch
                        })}
                        onChange={hasOnChange ? props.onChange : onChange}
                        isDisabled={disabled}
                        value={option.filter((q) => q?.value === props?.field?.value)}
                        styles={colorStyles}
                    />
                    <ErrorMessage name={props?.field?.name} render={EInvalidFeedback} />
                </>
            )
        }
        if (props.isAsyncSelectWithCreatable) {
            return (
                <>
                    <AsyncCreatableSelect
                        name={props?.field?.name}
                        isClearable={props.isClearable}
                        placeholder={props.placeholder}
                        loadOptions={loadOptions}
                        className={classNames(props.className, {
                            'is-invalid': errorMessage && isTouch
                        })}
                        createOptionPosition={props?.createOptionPosition || 'last'}
                        onChange={hasOnChange ? props.onChange : onChange}
                        isDisabled={disabled}
                        value={option.filter((q) => q?.value === props?.field?.value)}
                        isValidNewOption={props?.isValidNewOption}
                    />
                    <ErrorMessage name={props?.field?.name} render={EInvalidFeedback} />
                </>
            )
        }
        if (props.isSelectWithCreatable) {
            return (
                <>
                    <CreatableSelect
                        {...props.field}
                        {...props}
                        value={option.filter((q) => q.value === props.field.value)}
                        onChange={props?.hasOnChange ? props.onChange : onChange}
                        className={classNames(props.className, {
                            'is-invalid': errorMessage && isTouch
                        })}
                        options={option}
                    />
                    <ErrorMessage name={props?.field?.name} render={EInvalidFeedback} />
                </>
            )
        }

        return (
            <>
                <Select
                    {...props.field}
                    {...props}
                    value={option.filter((q) => q.value === props.field.value)}
                    onChange={props?.hasOnChange ? props.onChange : onChange}
                    className={classNames(props.className, {
                        'is-invalid': errorMessage && isTouch
                    })}
                    options={option}
                />
                <ErrorMessage name={props?.field?.name} render={EInvalidFeedback} />
            </>
        )
    }
    return (
        <>
            <Input
                {...props.field}
                {...props}
                onChange={hasOnChange ? props.onChange : onChange}
                className={classNames(props.className, {
                    'is-invalid': errorMessage && isTouch
                })}
            >
                {!onlyShowOption ? <option value=''>Select </option> : null}
                {Array.isArray(option)
                    ? option.map((opt) => (
                          <option
                              value={opt?.value}
                              key={opt?.value}
                              disabled={opt?.disabled}
                              className={classNames({ 'bg-warning': opt?.highlight })}
                          >
                              {opt?.label}
                          </option>
                      ))
                    : null}
            </Input>
            <ErrorMessage name={props?.field?.name} render={EInvalidFeedback} />
        </>
    )
}

export default SelectField
